import {Box, Typography} from "@mui/material";
import prata from "../../assets/prata.png";
import React from "react";

export default function InsuranceSilver() {
    return (
        <Box
            sx={{
                background: 'linear-gradient(to right, #272727, #5D566B)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 1,
            }}
        >
            <Box>
                <img
                    src={prata}
                    alt="Plano prata"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '50%',
                    }}
                />
            </Box>
            <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', color: 'white' }}>
                Prata
            </Typography>
            <Typography variant="body2" color="white">
                Plano de 24 meses
            </Typography>
        </Box>
    )
}